module.exports = __webpack_public_path__ + "media/wetlands.d41e6a23.svg";